import { IsEnum, IsInt, IsNotEmpty, IsOptional, Min, ValidateIf } from 'class-validator';

import { FieldImageProportion } from './field-image-proportion';

/**
 * @see backend-php/modules/rest_common/models/taxonomy/FieldImage.php
 */
export class FieldImageOptions {
    @IsOptional()
    @IsInt()
    @Min(1)
    public width: number;

    @IsOptional()
    @IsInt()
    @Min(1)
    public height: number;

    @ValidateIf((o: FieldImageOptions) => !!o.proportion || (!!o.width && !!o.height))
    @IsNotEmpty({ message: 'Укажите вид ограничения - "точное соответствие" или "не более, чем"' })
    @IsEnum(FieldImageProportion, { message: 'Неправильное значение пропорций' })
    public proportion: FieldImageProportion;

    constructor(data?: Partial<FieldImageOptions>) {
        this.width = data?.width;
        this.height = data?.height;
        this.proportion = data?.proportion;
    }
}
